module.exports = __webpack_public_path__ + "img/graphy-2.23ec992a.png";